<template>
  <div class="el-calendar my">
    <div class="el-calendar__header">
      <div class="el-calendar__title">
        {{date}}
      </div>
      <div class="el-calendar__button-group">
        <div class="el-button-group"><button type="button" class="el-button el-button--plain el-button--mini">
            <span>
              上周
            </span></button><button type="button" class="el-button el-button--plain el-button--mini">

            <span>
              今天
            </span></button><button type="button" class="el-button el-button--plain el-button--mini">

            <span>
              下周
            </span></button></div>
      </div>
    </div>
    <div class="el-calendar__body">
      <table cellspacing="0" cellpadding="0" class="el-calendar-table custom-table venue">
        <thead>
          <th>展厅</th>
          <th>一</th>
          <th>二</th>
          <th>三</th>
          <th>四</th>
          <th>五</th>
          <th>六</th>
          <th>日</th>
        </thead>
        <tbody>
          <tr class="el-calendar-table__row" v-for="item in explainList">
            <td>
              <div class="el-calendar-day thead-vertical">
                <div>{{item.exhibitionName}}</div>
                <div class="fontcolor-grey mat10">{{item.floor}}</div>
              </div>
            </td>
            <td v-for="cItem in item.baseInfoList">
              <div class="el-calendar-day">
                <div class="calendar-custom">
                  <ul class="calendar-data">
                    <template v-if="cItem.detailInfoList.length">
                      <li v-for="ccItem in cItem.detailInfoList" :title="ccItem.taskTime+' '+ccItem.volunteerName">
                        <span class="time">{{ccItem.taskTime}}</span>
                        <span class="name">{{ccItem.volunteerName}}</span>
                        <!-- <i class="eat iconfont icon-canyin-active"></i> -->
                      </li>
                    </template>
                    <template v-else>
                      <div style="text-align:center;line-height:100px;color: #797979;">暂无活动</div>
                    </template>
                  </ul>
                </div>
              </div>
            </td>
          </tr>

        </tbody>
      </table>
      <table cellspacing="0" cellpadding="0" class="el-calendar-table custom-table service mat10">
        <tbody>
          <tr class="el-calendar-table__row">
            <td>
              <div class="el-calendar-day thead-vertical">
                <div>服务</div>
              </div>
            </td>
            <td v-for="item in serviceList">
              <div class="el-calendar-day">
                <div class="calendar-custom">
                  <ul class="calendar-data">
                    <template v-if="item.detailInfoList.length">
                      <li>
                        <template v-for="cItem in item.detailInfoList">
                          <div class="time">{{cItem.taskTime}}</div>
                          <div :title="cItem.volunteerName">
                            <template v-if="cItem.volunteerName">
                              <span style="margin-right:10px" v-for="ccItem in cItem.volunteerName.split(',')">{{ccItem}}</span>
                            </template>
                          </div>

                        </template>

                      </li>
                    </template>
                    <template v-else>
                      <div style="text-align:center;line-height:100px;color: #797979;">暂无活动</div>
                    </template>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <table cellspacing="0" cellpadding="0" class="el-calendar-table custom-table plan mat10">
        <tbody>
          <tr class="el-calendar-table__row">
            <td>
              <div class="el-calendar-day thead-vertical">
                <div>策划</div>
              </div>
            </td>
            <td v-for="item in planList">
              <div class="el-calendar-day">
                <div class="calendar-custom">
                  <ul class="calendar-data">
                    <template v-if="item.detailInfoList.length">
                      <li>
                        <template v-for="cItem in item.detailInfoList">

                          <div class="time">{{cItem.taskTime}}</div>
                          <template v-if="cItem.volunteerName">
                            <div :title="cItem.volunteerName">
                              <span style="margin-right:10px" v-for="ccItem in cItem.volunteerName.split(',')">{{ccItem}}</span>
                            </div>
                          </template>
                        </template>
                      </li>
                    </template>
                    <template v-else>
                      <div style="text-align:center;line-height:100px;color: #797979;">暂无活动</div>
                    </template>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <table cellspacing="0" cellpadding="0" class="el-calendar-table custom-table activity mat10">
        <tbody>
          <tr class="el-calendar-table__row">
            <td>
              <div class="el-calendar-day thead-vertical">
                <div>其他活动</div>
              </div>
            </td>
            <td v-for="item in activityList">
              <div class="el-calendar-day">
                <div class="calendar-custom">
                  <ul class="calendar-data">
                    <template v-if="item.detailInfoList.length">
                      <li>
                        <template v-for="cItem in item.detailInfoList">
                          <div class="time">{{cItem.taskTime}}</div>
                          <template v-if="cItem.volunteerName">
                            <div :title="cItem.volunteerName">
                              <span style="margin-right:10px" v-for="ccItem in cItem.volunteerName.split(',')">{{ccItem}}</span>
                            </div>
                          </template>
                        </template>
                      </li>
                    </template>
                    <template v-else>
                      <div style="text-align:center;line-height:100px;color: #797979;">暂无活动</div>
                    </template>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import calendar from '@/libs/calendar';
import { getWeekStartAndEndDate } from '@/libs/utils'
export default {
  components: {},
  props: {
    calendarData: {
      //日历中有事件的数组
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentDate: new Date(),
      date: getWeekStartAndEndDate('', 1),
      dateFormat: getWeekStartAndEndDate('', 3),
      explainList: [],
      serviceList: [],
      planList: [],
      activityList: []

    };
  },
  computed: {},
  watch: {
    date() {
      this.$emit("change-date", this.dateFormat);
    },
    calendarData() {
      // console.log(this.calendarData)
      this.explainList = this.calendarData.explainInfo
      this.serviceList = this.calendarData.serviceInfo
      this.planList = this.calendarData.planInfo
      this.activityList = this.calendarData.otherInfo
    }
  },
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      // 点击上周
      let prevBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(1)"
      );
      prevBtn.addEventListener("click", e => {
        let current = this.currentDate;
        let timestamp = Date.parse(current) - 7 * 24 * 60 * 60 * 1000;  //时间戳
        this.currentDate = new Date(timestamp)
        this.date = getWeekStartAndEndDate(timestamp, 1)
        this.dateFormat = getWeekStartAndEndDate(timestamp, 3)
      });

      //点击下周
      let nextBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(3)"
      );
      nextBtn.addEventListener("click", () => {
        let current = this.currentDate;
        let timestamp = Date.parse(current) + 7 * 24 * 60 * 60 * 1000;  //时间戳
        this.currentDate = new Date(timestamp)
        this.date = getWeekStartAndEndDate(timestamp, 1)
        this.dateFormat = getWeekStartAndEndDate(timestamp, 3)

      });

      //点击今天
      let todayBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(2)"
      );
      todayBtn.addEventListener("click", () => {
        this.currentDate = new Date()
        this.date = getWeekStartAndEndDate("", 1)
        this.dateFormat = getWeekStartAndEndDate('', 3)
      });
    });

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$emit("change-date", this.dateFormat);
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
@import "~@views/serviceCenter/components/calendar/calendar.less";

/deep/.el-calendar-table .el-calendar-day {
  min-height: 240px;
  // height: auto;
}
/deep/ .el-calendar-table .el-calendar-day {
  height: auto;
}
.calendar-data {
  margin: 0;
  min-height: 220px;
  li {
    .time {
      width: 43px;
    }

    .name {
      margin-right: 10px;
      width: calc(100% - 43px);
    }
  }
}
.service,
.plan,
.activity {
  .calendar-data {
    li {
      display: inline-block;
      .time {
        width: 100%;
        text-align: left;
        margin-right: 0;
      }
    }
  }
}
</style>
